<template>
  <vs-row style="height: 100%; position:relative;">
    <vs-col vs-w="12">
      <div class="vx-card form-card" ref="card">
        <div class="vx-card__header">
          <vs-col vs-type="flex" vs-justify="space-between" vs-align="center" vs-w="12" vs-lg="12" vs-sm="12" vs-xs="12">
            <h3>INVIA DOCUMENTO</h3>
            <vs-col :vs-w="this.selected && this.selected.voci ? 1 : 3">
              <vs-button @click="save($event)"  icon-pack="feather" icon="icon-send" color="success" type="line" align="right">Invia</vs-button>
            </vs-col>
            <feather-icon icon="XIcon" @click="closeSidebar" class="cursor-pointer"></feather-icon>
          </vs-col>
        </div>
        <vs-divider />
        <div class="vx-card__body">
          <vs-row vs-type="flex" >
            <vs-col v-if="this.selected && this.selected.voci" vs-type="flex" vs-w="7">
              <ShowPreventivo :selected="selected"></ShowPreventivo>
            </vs-col>

            <vs-col vs-type="flex" :vs-w="this.selected && this.selected.voci ? 5 : 12">
              <form v-on:submit.prevent="" data-vv-scope="mail" autocomplete="off">
                <vs-row>
                  <vs-col >
                    <label class="vs-input--label">Emails</label>
                    <v-select multiple taggable push-tags name="emails" placeholder="Inserisci i destinatari" :options="emails" v-model="to" v-validate="'required|email'" >
                      <template #no-options="{ search, searching, loading }">
                        Digita la mail da inserire e premi "invio"
                      </template>
                    </v-select>
                    <!-- <v-select @option:created="checkMail" taggable push-tags name="tipo" placeholder="Inserisci i destinatari" :options="emails"  v-model="to" v-validate="'required|email'" /> -->
                    <!-- <vs-input class="w-full" v-model="to" name="to" placeholder="Inserisci i destinatari separati da virgola..." v-validate="'required'" /> -->
                    <span class="text-danger text-sm">{{to_error}}</span>
                  </vs-col>
                  <vs-col class="mt-2">
                    <label class="vs-input--label">Oggetto</label>
                    <vs-input class="w-full" v-model="oggetto" name="oggetto" placeholder="Oggetto.." v-validate="'required|max:100'" />
                    <span class="text-danger text-sm" v-show="errors.has('mail.oggetto')">{{ errors.first('mail.oggetto') }}</span>
                  </vs-col>
                  <vs-col class="mt-2">
                    <label class="vs-input--label">Messaggio</label>
                    <vs-textarea v-model="messaggio" name="messaggio" v-validate="'required|max:600'" />
                    <span class="text-danger text-sm" v-show="errors.has('mail.messaggio')">{{ errors.first('mail.messaggio') }}</span>
                  </vs-col>
                  <vs-col class="mt-2">
                    <vs-checkbox v-model="send_to_me" >Invia anche alla mia mail</vs-checkbox>
                  </vs-col>
                </vs-row>
              </form>
            </vs-col>
          </vs-row>
        </div>
      </div>
    </vs-col>
  </vs-row>
</template>

<script>
import axios from 'axios'

// For custom error message
import { Validator } from 'vee-validate';

// vue-select
import vSelect from 'vue-select'

import * as fs from 'fs';
import ShowPreventivo from './ShowPreventivo.vue'

const dict = {
  custom: {
    emails: {
      required: 'Destinatario è un campo obbligatorio',
      email: 'Mail non valida'
    },
    oggetto: {
      required: 'Oggetto è un campo obbligatorio',
      max: "Max 100 caratteri",
    },
    messaggio: {
      required: 'Messaggio è un campo obbligatorio',
      max: "Max 600 caratteri",
    },
  }
};

// register custom messages
Validator.localize('it', dict);

export default {
  data() {
    return {
      emails: [],
      to: [],
      to_error: "",
      oggetto: "",
      messaggio: "",
      send_to_me: false,
      display_logo: ""
    }
  },

  props: {
    selected: Object,
    stato_inviato: Number
  },

  mounted() {

    if(this.selected && this.selected.voci) {
      this.eachVoceDesc()
      this.display_logo = this.$tariffe.checkLogo(this.selected.voci)
      if (this.selected.azienda && (this.selected.azienda.email_dl || this.selected.azienda.email_dc)) {
        this.to.push(this.selected.azienda.email_dc ? this.selected.azienda.email_dc : this.selected.azienda.email_dl)
      }
      this.oggetto = ["Preventivo n.",this.selected.numero," da Cedascom Spa"].join('')
      this.messaggio = ["Gentile ",
                        this.selected.azienda ? this.selected.azienda.ragione_sociale : [this.selected.contatto.cognome,this.selected.contatto.nome].join(' '),
                        ` per vedere la tua proposta commerciale, fai click sul bottone sotto.
In allegato trovi anche una copia in PDF per i tuoi registri.

Cordiali saluti,
`,
                        [localStorage.utente_cognome,localStorage.utente_nome].join(' ')].join('')
    } else {
      if (this.selected && this.selected.preventivo) {
        if (this.selected.preventivo.azienda && (this.selected.preventivo.azienda.email_dl || this.selected.preventivo.azienda.email_dc)) {
          this.to.push(this.selected.preventivo.azienda.email_dc ? this.selected.preventivo.azienda.email_dc : this.selected.preventivo.azienda.email_dl)
        }
        this.oggetto = ["Contratto n.",this.selected.numero," da Cedascom Spa"].join('')
        this.messaggio = ["Gentile ",
                          this.selected.preventivo.azienda.ragione_sociale,
                          ` ecco il documento.

        Cordiali saluti,
        `,
                          [localStorage.utente_cognome,localStorage.utente_nome].join(' ')].join('')
      }
    }
  },

  methods: {
    // eachVoceDesc() {
    //   let ls = document.getElementsByClassName('quill')
    //   for (let [key, value] of Object.entries(ls)) {
    //     this.selected['voci'].forEach( (v,idx) => {
    //       if (ls[key].id == 'quill-'+idx)
    //         ls[key].innerHTML = v.tariffa_applicata.descrizione;
    //     })
    //   }
    // },
    eachVoceDesc() {
      let ls = document.getElementsByClassName('quill')
      let incl = this.selected['voci'].filter( v => { if (v.tariffa_applicata.quantifier != '0' && v.tariffa_applicata.quantifier != 'u') return v})
      let escl = this.selected['voci'].filter( v => { if (v.tariffa_applicata.quantifier == '0' || v.tariffa_applicata.quantifier == 'u') return v})
      for (let [key, value] of Object.entries(ls)) {
        incl.forEach( (v,idx) => {
            if (ls[key].id == 'quill-'+idx)
              ls[key].innerHTML = v.tariffa_applicata.descrizione;
          })
        escl.forEach( (v,idx) => {
            if (ls[key].id == 'quill-'+(idx+incl.length))
              console.log(v.tariffa_applicata.descrizione+'-----')
              ls[key].innerHTML = v.tariffa_applicata.descrizione;
          })
      }
    },

    async generatePDF(preventivo,mail) {
      this.activeLoading = true
      this.$vs.loading({
        type:'radius',
      })
      let p_to_print = {...preventivo}
      if (this.selected.voci) {
        axios.post(process.env.VUE_APP_BACKEND_API+'/tariffa_servizio/generate_file', {
          templates: [{nuovo_nome: 'preventivo.docx'}],
          object: this.$tariffe.generatePDFpreventivo(p_to_print),
          save: true
        },{
          headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
          withCredentials: true,
          responseType: 'blob'
        }).then(
          response => {
            let dpath = './storage/documenti/to_send.pdf'
            mail['file'] =   {
                filename: 'preventivo.pdf',
                path: dpath
            }
            mail['token'] = preventivo.token
            axios.post(process.env.VUE_APP_BACKEND_API+'/preventivo/invia_doc', mail, {
                headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
                withCredentials: true,
            }).then(res => {
              if(this.selected.stato.ordine == 0) {
                axios.post(process.env.VUE_APP_BACKEND_API+'/preventivo/avanza_stato', {id: this.selected['id'], id_stato: this.stato_inviato },{
                headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
                withCredentials: true,
              })}
              this.$vs.loading.close()
              this.$emit('mail-inviata')
            })
          }).catch(e => {
            console.log(e)
            this.$vs.loading.close()
        })
      } else {
        p_to_print = await this.$tariffe.generatePDFcontratto(p_to_print),
        axios.post(process.env.VUE_APP_BACKEND_API+'/tariffa_servizio/generate_file', {
          templates: p_to_print.templates,
          object: p_to_print,
          save: true
        },{
          headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
          withCredentials: true,
          responseType: 'blob'
        }).then(response => {
            let dpath = './storage/documenti/to_send.pdf'
            mail['file'] =   {
                filename: 'contratto.pdf',
                path: dpath
            }
            mail['token'] = preventivo.token
            axios.post(process.env.VUE_APP_BACKEND_API+'/contratto/invia_doc', mail, {
                headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
                withCredentials: true,
            }).then(res => {
              if(this.selected.stato.ordine == 0) {
              axios.post(process.env.VUE_APP_BACKEND_API+'/contratto/avanza_stato', {id: this.selected['id'], id_stato: this.stato_inviato },{
              headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
              withCredentials: true,
              }).then( r => {
                this.$vs.loading.close()
                this.$emit('mail-inviata')
              })}
            })
        }).catch(e => {
          console.log(e)
          this.$vs.loading.close()
        })
      }
    },
    buildSaveObject() {
      return {
        to: this.to,
        subject: this.oggetto,
        message: this.messaggio
      }
    },
    save(ev) {
      this.validateAll().then(() => {
        let mail = this.buildSaveObject()
        this.generatePDF(this.selected,mail)
      }).catch(e => {
            console.log(e)
            this.$vs.loading.close()
        })
    },
    validateAll() {
      console.log('VALIDATE MAIL');
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('mail').then(result => {
          if (result) {
            resolve(true)
          } else {
            this.$validator.errors.items.forEach( er => {
              if (er.field == 'emails') this.to_error = er.msg
            })
            reject("correct all values");
          }
        })
      })
    },
    closeSidebar(ev) {
      this.$emit('close-me')
      ev.stopPropagation()
    },
    getNumero(n,date) {
      let d_n = new Date(date).getYear() + 1900
      return [n,'/',d_n].join('')
    },
  },

  components: {
    vSelect,
    ShowPreventivo,
  },

  watch: {
    send_to_me(val) {
      if (val) {this.to.push(localStorage.utente_mail)}
      else {
        this.to = this.to.filter(el => el != localStorage.utente_mail)
      }
    }
  }
}
</script>


<style lang="scss">
.vs-textarea {
  height: 200px;
}
</style>
